<div class="modal-header">
  <h4 class="modal-title pull-left"> User Position</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <b style="font-size: 16px;">{{user.getName()}} doesn't have {{position | position}} Position </b>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="gotoProfile()">Edit User</button>
</div>
